import { isOrvalServerError } from '@r/api/orval-error-helper.ts';
import { MAINTENANCE_CRITICAL_RETRY_COUNT } from '@r/lib/maintenance-critical-api.ts';

/**
 * Callback `retry` React Query : ne retente que les HTTP 500, jusqu'à
 * {@link MAINTENANCE_CRITICAL_RETRY_COUNT} fois (3 tentatives au total).
 * Les 503 ne sont pas retentés (maintenance plateforme → page immédiate).
 */
export function maintenanceCriticalQueryRetry(failureCount: number, error: unknown): boolean {
  return isOrvalServerError(error) && failureCount < MAINTENANCE_CRITICAL_RETRY_COUNT;
}

/**
 * Délai entre deux tentatives (backoff exponentiel, plafonné à 4 s).
 */
export function maintenanceCriticalRetryDelay(attemptIndex: number): number {
  return Math.min(1000 * 2 ** attemptIndex, 4000);
}

/** Options à spread sur les queries bootstrap (config, routes, /me). */
export const maintenanceCriticalQueryOptions = {
  retry: maintenanceCriticalQueryRetry,
  retryDelay: maintenanceCriticalRetryDelay
} as const;
